import React, { isValidElement } from 'react';

import { FooterSlots } from './FooterSlots';
import type { RootFooterProps } from './types';

const initialSlots = {
  socials: null,
  topSection: null,
  languagePicker: null,
} as const;

/**
 * Extracts the slots from the children and allows them to be used in the component
 * @param children
 * @returns The slots object with the slots
 */
export const useFooterSlots = (children: RootFooterProps['children']) => {
  const slots = React.Children.toArray(children).reduce<
    Record<keyof typeof initialSlots, React.ReactNode>
  >((acc, child) => {
    if (isValidElement(child)) {
      if (child.type === FooterSlots.Socials) acc.socials = child;
      if (child.type === FooterSlots.TopSection) acc.topSection = child;
      if (child.type === FooterSlots.LanguagePicker) acc.languagePicker = child;
    }
    return acc;
  }, initialSlots);

  return slots;
};
